import { brandApi } from "@/lib/axios";
import {
  ThankYouBannerManagementResponse,
  UpdateThankYouBannerPayload,
} from "@/types/brand";

export const thankYouBannerService = {
  async getConfig(): Promise<ThankYouBannerManagementResponse> {
    const { data } = await brandApi.get<ThankYouBannerManagementResponse>(
      "/thank-you-banner/me"
    );
    return data;
  },

  async updateConfig(
    payload: UpdateThankYouBannerPayload
  ): Promise<ThankYouBannerManagementResponse> {
    const { data } = await brandApi.put<ThankYouBannerManagementResponse>(
      "/thank-you-banner/me",
      payload
    );
    return data;
  },
};


